// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"70911247e0a51159","6831":"d2544528f9f504d0","8503":"9bdaea2419c21541","9683":"070ab99b9492b01c"}[chunkId] + ".js";
};